import { I18n } from "localisation/i18n";

const strings = (name: string, params = {}) => I18n.t(name, params);

export default strings;
